import React from 'react';
import styled from 'styled-components';
import { colors } from '../../../constants/colors';
import { fontFamily, fontSize } from '../../../constants/text';
import { smallerThan } from '../../../core/util/styledComponents';

const Tag = styled.button`
  appearance: none;
  border: none;
  background: ${colors.karl};
  color: ${colors.darkText};
  padding: 10px 25px;
  border-radius: 100000px;
  font-family: ${fontFamily.book};
  transition: background 0.15s;
  font-size: ${fontSize.default};
  cursor: pointer;

  ${smallerThan.md`
    font-size: ${fontSize.mediumSmall};
  `}

  &:focus {
    outline: none;
  }

  &:hover {
    background: ${colors.grayvy};
  }
`;

type Props = {
  /** The title of the service to display */
  title: string;

  /** An action to take when clicking the service */
  onClick: () => void;
};

/**
 * A small tag representing a single service or symptom
 */
const ServiceTag = ({ title, onClick }: Props) => {
  return <Tag onClick={onClick}>{title}</Tag>;
};

export default ServiceTag;
